module.exports = __webpack_public_path__ + "img/email.e89b8bda.png";